// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.QuestionsTable {
  --border: 1px solid rgba(0, 0, 0, 0.15);
  min-height: calc(100vh - var(--header-height));
  margin-top: 1.5rem;
}
.Table.QuestionsTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
  border-width: 1px 0;
  table-layout: fixed;
  border-radius: 0.833rem;
}
.Table.QuestionsTable table .TableRow {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 4rem;
}
.Table.QuestionsTable table .TableRow + .TableRow,
.Table.QuestionsTable table .TableRow + .Table-End {
  border-top: var(--border);
}
.Table.QuestionsTable table .TableRow.selected {
  background-color: var(--vt-selected-shading);
}
.Table.QuestionsTable table .TableRow.QuestionsTableRow--dragging {
  opacity: 0.5;
}
.Table.QuestionsTable table .TableRow.QuestionsTableRow--faded {
  position: relative;
}
.Table.QuestionsTable table .TableRow.QuestionsTableRow--faded::after {
  content: "";
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  pointer-events: none;
}
.Table.QuestionsTable table .TableRow.TableRow-Header {
  border-bottom: var(--border);
  border-top-left-radius: 0.833rem;
  border-top-right-radius: 0.833rem;
}
.Table.QuestionsTable table .TableRow.TableRow-Header .TableCell-Content {
  display: flex;
  align-items: center;
  font-size: 1.1667rem;
  font-weight: 700;
}
.Table.QuestionsTable table .TableRow .TableCell {
  display: flex;
  min-width: 0;
}
.Table.QuestionsTable table .TableRow .TableCell .TableCell-Content {
  padding: 0.35rem;
  align-content: center;
  white-space: nowrap;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  min-width: 0;
  width: 100%;
}
.Table.QuestionsTable table .TableRow .TableCell.DRAG {
  flex: 0.1;
}
.Table.QuestionsTable table .TableRow .TableCell.DRAG .TableCell-Content {
  text-align: center;
}
.Table.QuestionsTable table .TableRow .TableCell.ITEM {
  flex: 4;
}
.Table.QuestionsTable table .TableRow .TableCell.CATEGORY {
  flex: 1.5;
}
.Table.QuestionsTable table .TableRow .TableCell.CATEGORY .badge {
  font-size: 1rem;
}
.Table.QuestionsTable table .TableRow .TableCell.ACTIONS {
  flex: 0.3;
}
.Table.QuestionsTable table .TableRow .TableBody {
  border-bottom-left-radius: 0.833rem;
  border-bottom-right-radius: 0.833rem;
}
.Table.QuestionsTable .Table-Controls {
  margin-right: 0.5rem;
}
.Table.QuestionsTable .QuestionsTableRow-Item {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  width: 100%;
}
.Table.QuestionsTable .QuestionsTableRow-Item .QuestionsTableRow-Name {
  font-size: 1.1667rem;
  font-weight: 700;
}
.Table.QuestionsTable .QuestionsTableRow-Item .QuestionsTableRow-Description {
  color: var(--bs-gray-600);
  font-size: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  max-width: 100%;
}
.Table.QuestionsTable .QuestionsTableRow-DragIcon {
  display: inline-block;
  width: 1.0833rem;
  height: 1.6667rem;
  cursor: grab;
}
.Table.QuestionsTable .QuestionsTableRow-Actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}
.Table.QuestionsTable .QuestionsTableRow-IconButton {
  background: none;
  border: none;
  padding: 0.25rem;
  margin: 0;
  line-height: 1;
  border-radius: 0.25rem;
  color: var(--bs-primary);
  text-decoration: none;
}
.Table.QuestionsTable .QuestionsTableRow-IconButton i {
  font-size: 1.3333rem;
  width: 1.3333rem;
  height: 1.3333rem;
  pointer-events: none;
}
.Table.QuestionsTable .QuestionsTableRow-IconButton:hover, .Table.QuestionsTable .QuestionsTableRow-IconButton:focus-visible {
  background-color: rgba(var(--bs-primary-rgb), 0.1);
}
.Table.QuestionsTable .QuestionsTableRow-IconButton:focus-visible {
  outline: 2px solid var(--bs-primary);
  outline-offset: 2px;
}
.Table.QuestionsTable .QuestionsTableRow-IconButton--danger {
  color: var(--bs-danger);
}
.Table.QuestionsTable .QuestionsTableRow-IconButton--danger:hover, .Table.QuestionsTable .QuestionsTableRow-IconButton--danger:focus-visible {
  background-color: rgba(var(--bs-danger-rgb), 0.1);
}
.Table.QuestionsTable .QuestionsTableRow-IconButton--danger:focus-visible {
  outline-color: var(--bs-danger);
}`, "",{"version":3,"sources":["webpack://./src/features/Settings/pages/Questions/components/QuestionsTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,8CAAA;EACA,kBAAA;AADF;AAGE;EACE,gDAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAGI;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AADN;AAGM;;EAEE,yBAAA;AADR;AAIM;EACE,4CAAA;AAFR;AAKM;EACE,YAAA;AAHR;AAMM;EACE,kBAAA;AAJR;AAMQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,oBAAA;AAJV;AAQM;EACE,4BAAA;EACA,gCAAA;EACA,iCAAA;AANR;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AALV;AASM;EACE,aAAA;EACA,YAAA;AAPR;AASQ;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAPV;AAUQ;EACE,SAAA;AARV;AASU;EACE,kBAAA;AAPZ;AAWQ;EACE,OAAA;AATV;AAYQ;EACE,SAAA;AAVV;AAYU;EACE,eAAA;AAVZ;AAcQ;EACE,SAAA;AAZV;AAeM;EACE,mCAAA;EACA,oCAAA;AAbR;AAkBE;EACE,oBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAjBJ;AAmBI;EACE,oBAAA;EACA,gBAAA;AAjBN;AAoBI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAlBN;AAsBE;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AApBJ;AAuBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;AArBJ;AAwBE;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;AAtBJ;AAwBI;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAtBN;AAyBI;EAEE,kDAAA;AAxBN;AA2BI;EACE,oCAAA;EACA,mBAAA;AAzBN;AA4BI;EACE,uBAAA;AA1BN;AA4BM;EAEE,iDAAA;AA3BR;AA8BM;EACE,+BAAA;AA5BR","sourcesContent":["@import '../../../../../../globals.scss';\n\n.Table.QuestionsTable {\n  --border: 1px solid rgba(0, 0, 0, 0.15);\n  min-height: calc(100vh - var(--header-height));\n  margin-top: 1.5rem;\n\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    border-width: 1px 0;\n    table-layout: fixed;\n    border-radius: 0.833rem;\n\n    .TableRow {\n      display: flex;\n      align-items: stretch;\n      width: 100%;\n      min-height: 4rem;\n\n      + .TableRow,\n      + .Table-End {\n        border-top: var(--border);\n      }\n\n      &.selected {\n        background-color: var(--vt-selected-shading);\n      }\n\n      &.QuestionsTableRow--dragging {\n        opacity: 0.5;\n      }\n\n      &.QuestionsTableRow--faded {\n        position: relative;\n\n        &::after {\n          content: '';\n          position: absolute;\n          inset: 0;\n          background-color: rgba(0, 0, 0, 0.45);\n          pointer-events: none;\n        }\n      }\n\n      &.TableRow-Header {\n        border-bottom: var(--border);\n        border-top-left-radius: 0.833rem;\n        border-top-right-radius: 0.833rem;\n        .TableCell-Content {\n          display: flex;\n          align-items: center;\n          font-size: 1.1667rem; // 14px\n          font-weight: 700;\n        }\n      }\n\n      .TableCell {\n        display: flex;\n        min-width: 0;\n\n        .TableCell-Content {\n          padding: 0.35rem;\n          align-content: center;\n          white-space: nowrap;\n          text-align: left;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-weight: 700;\n          min-width: 0;\n          width: 100%;\n        }\n\n        &.DRAG {\n          flex: 0.1;\n          .TableCell-Content {\n            text-align: center;\n          }\n        }\n\n        &.ITEM {\n          flex: 4;\n        }\n\n        &.CATEGORY {\n          flex: 1.5;\n\n          .badge {\n            font-size: 1rem; // 12px\n          }\n        }\n\n        &.ACTIONS {\n          flex: 0.3;\n        }\n      }\n      .TableBody {\n        border-bottom-left-radius: 0.833rem;\n        border-bottom-right-radius: 0.833rem;\n      }\n    }\n  }\n\n  .Table-Controls {\n    margin-right: 0.5rem;\n  }\n\n  .QuestionsTableRow-Item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    white-space: normal;\n    word-break: break-word;\n    text-align: left;\n    width: 100%;\n\n    .QuestionsTableRow-Name {\n      font-size: 1.1667rem; // 14px\n      font-weight: 700;\n    }\n\n    .QuestionsTableRow-Description {\n      color: var(--bs-gray-600);\n      font-size: 1rem; // 12px\n      font-weight: 600;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      min-width: 0;\n      max-width: 100%;\n    }\n  }\n\n  .QuestionsTableRow-DragIcon {\n    display: inline-block;\n    width: 1.0833rem; // 13px\n    height: 1.6667rem; // 20px\n    cursor: grab;\n  }\n\n  .QuestionsTableRow-Actions {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .QuestionsTableRow-IconButton {\n    background: none;\n    border: none;\n    padding: 0.25rem;\n    margin: 0;\n    line-height: 1;\n    border-radius: 0.25rem;\n    color: var(--bs-primary);\n    text-decoration: none;\n\n    i {\n      font-size: 1.3333rem; // 16px\n      width: 1.3333rem; // 16px\n      height: 1.3333rem; // 16px\n      pointer-events: none;\n    }\n\n    &:hover,\n    &:focus-visible {\n      background-color: rgba(var(--bs-primary-rgb), 0.1);\n    }\n\n    &:focus-visible {\n      outline: 2px solid var(--bs-primary);\n      outline-offset: 2px;\n    }\n\n    &--danger {\n      color: var(--bs-danger);\n\n      &:hover,\n      &:focus-visible {\n        background-color: rgba(var(--bs-danger-rgb), 0.1);\n      }\n\n      &:focus-visible {\n        outline-color: var(--bs-danger);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
